// import Vue from 'vue'
import { Icon, Field, Tab, Tabs, Search, Image as VanImage } from 'vant'

const components = [Icon, Field, Tab, Tabs, Search, VanImage]

export function setVant(vue) {
  components.forEach(component => vue.use(component))
}
